import { render, staticRenderFns } from "./LabelVariablesDelta.vue?vue&type=template&id=5488b9a2&scoped=true"
import script from "./LabelVariablesDelta.vue?vue&type=script&lang=js"
export * from "./LabelVariablesDelta.vue?vue&type=script&lang=js"
import style0 from "./LabelVariablesDelta.vue?vue&type=style&index=0&id=5488b9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488b9a2",
  null
  
)

export default component.exports